import { lazy } from "react";

const Customers = lazy(() => import("../Customer/Customers"));
const AddEditCstmr = lazy(() =>
  import("../Customer/CustomerForm/AddEditCstmr")
);
const ViewCstmr = lazy(() =>
  import("../Customer/ViewCustomer/ViewCstmr")
);
const ImportCustomer = lazy(() =>
  import("../Customer/ImportCustomer/ImportCustomer")
);
const Groups = lazy(() => import("../Customer/Group/Groups"));

export const customerRoutes = (access, settings) => {
  if (!settings?.fiscalYearId) return [];

  const routes = [];

  if (access.customerGroupAccess) {
    routes.push({ path: "/customer_groups", element: Groups, title: "customerGroups" });
  }

  if (access.customerAccess) {
    routes.push(
      { path: "/customers", element: Customers, title: "customers" },
      { path: "/view_customer/:id", element: ViewCstmr, title: "viewCustomer" },
    );
    if (access.customer?.edit) {
      routes.push({ path: "/customer_form/:id", element: AddEditCstmr, title: "editCustomer" });
    }
    if (access.customer?.create) {
      routes.push(
        { path: "/customer_form", element: AddEditCstmr, title: "addCustomer" },
        { path: "/import_customers", element: ImportCustomer, title: "importCustomers" },
      );
    }
  }

  return routes;
};
